import { Record } from 'immutable';
export default class extends Record({
  activeListCount: null,
  completedListCount: null,
  enrolledListCount: null,
  startingListCount: null,
  startingListDoneProcessing: null,
  succeededListCount: null
}, 'ContactListCounts') {}